var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h4",attrs:{"data-test":"h4"}},[_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }